import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';

export type PaginationType = {
  first: boolean;
  formatTotal: string;
  last: boolean;
  page: number;
  pages: number;
  pagesize: number;
  total: number;
};

const Pagin = ({
  pagination,
  handlePageChange,
}: {
  pagination: PaginationType;
  handlePageChange: (event: any, value: number) => void;
}) => {
  return (
    <Stack
      justifyContent={'center'}
      alignItems={'center'}
      height={'60px'}
    >
      <Pagination
        count={pagination.pages}
        page={pagination.page}
        siblingCount={2}
        boundaryCount={1}
        shape='rounded'
        onChange={(event, value) => handlePageChange(event, value)}
        sx={{
          '& .MuiButtonBase-root.MuiPaginationItem-root': {
            color: 'primary.dark',
          },
          '& .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected': {
            background: 'linear-gradient(95.64deg, #00C3FF 0%, #0090F8 100%)',
            color: 'primary.light',
          },
        }}
        renderItem={(item) => (
          <PaginationItem
            slots={{
              previous: KeyboardDoubleArrowLeftIcon,
              next: KeyboardDoubleArrowRightIcon,
            }}
            {...item}
          />
        )}
      />
    </Stack>
  );
};

export default Pagin;
